module.exports = __webpack_public_path__ + "img/life-at-ommax-5.fa9781ab.jpg";